import { CoordinatorService } from "./coordinator.service"

export class System$ {
    constructor(public coords: CoordinatorService) {

    }

    private async _isCloud(entry: FileSystemDirectoryHandle) {
        try {
            await entry.getFileHandle(".isCloudProject")
            return true
        } catch (e) {
            return false
        }
    }

    async clearCache(params?: {
        clearCloud: boolean, clearLocal: boolean
    }) {
        if (!params) {
            params = { clearCloud: true, clearLocal: false }
        }
        const rH = await navigator.storage.getDirectory() as any
        if (params.clearCloud) {
            await this.clearAttachmentCache()
        }
        for await (const entry of rH.values()) {
            if (entry.name.startsWith("_")) continue
            let cTest = await this._isCloud(entry)

            if ((params.clearCloud && cTest) || (params.clearLocal && !cTest))
                await this.removeProject(entry, rH)
        }
        return true
    }

    async clearAttachmentCache() {
        try {
            const rH = await navigator.storage.getDirectory() as any
            const aH = await rH.getDirectoryHandle("_attachments")
            for await (const entry of aH.values()) {
                entry.remove()
            }
            return true
        } catch (e) {
            return true
        }
    }

    async fileSize(fH: FileSystemFileHandle) {
        try {
            const file = await fH.getFile()
            return file.size
        } catch (e) {
            return 0
        }
    }

    async directorySize(dHandle: FileSystemDirectoryHandle) {
        const dH = dHandle as any
        let totalSize = 0
        let cTest = false

        for await (const entry of dH.values()) {
            if (entry.kind === 'file') {
                // Add the size of the file to the total size
                if (entry.name === ".isCloudProject")
                    cTest = true
                else
                    totalSize += await this.fileSize(entry)
            } else if (entry.kind === 'directory') {
                // Recursively get the size of the directory and add it to the total size
                totalSize += (await this.directorySize(entry)).size
            }
        }
        return {
            size: totalSize,
            isCloud: cTest
        }
    }

    async removeProject(pH: FileSystemDirectoryHandle, rH?: FileSystemDirectoryHandle) {
        if (!rH)
            rH = await navigator.storage.getDirectory()
        await rH.removeEntry(pH.name, { recursive: true })
    }

    async filesystemSummary() {
        const est = await navigator.storage.estimate()
        const avail = (est.quota || 0) - (est.usage || 0)
        const resp = {
            available: avail,
            localSize: 0,
            cloudSize: 0,
            attachmentsSize: 0
        }
        const rH = await navigator.storage.getDirectory() as any
        for await (const entry of rH.values()) {
            if (entry.name === "_attachments")
                resp.attachmentsSize = (await this.directorySize(entry)).size
            if (entry.name.startsWith("_")) continue
            const d = await this.directorySize(entry)
            if (d.isCloud)
                resp.cloudSize += d.size
            else
                resp.localSize += d.size
        }

        return resp
    }

}
